import React from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import CreateAccount from 'app/components/CreateAccount/CreateAccount';
import ProfileSettings from 'app/components/ProfileSettings/ProfileSettings';

import MToolbar from 'app/ui/MToolbar/MToolbar';
import MSelect from 'app/ui/MSelect/MSelect';

import * as fromApp from '../../store/app';

import { IUser } from 'app/models/user';
import { ILang } from 'app/ui/MToolbar/MToolbar.model';

import classes from './ToolbarNavigation.module.scss';
import { Routes } from 'routes';
import { Authorization, Clients } from 'app/enums/clients';
import { LocalStorage } from '../../constants/StorageConstants';
import { ISupplier } from 'app/models/supplier';

interface PropsFromState {
  user: IUser | null;
  logo: string;
  client: Clients | null;
  supplier: ISupplier | null;
  authorization: Authorization[];
}

interface Props extends PropsFromState {
  languages: ILang[];
  languagesFlag: boolean;
  currentLanguageState: ILang | null;
  popupCreateAccountState: boolean;
  onChangelanguage: (selectedValue: string) => void;
  onClosePopupCreateAccount: () => void;
  onOpenPopupCreateAccount: () => void;
  onLogoClick: () => void;
}

const ToolbarNavigationView: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  const { t } = useTranslation();

  const menu = [
    {
      label: t('toolbarNavigation.home'),
      to: `/?client=${localStorage.getItem(LocalStorage.Client)}&supplier=${props.supplier?.name}`,
    },
    {
      label: t('toolbarNavigation.contact'),
      to: Routes.Contact,
    },
  ];

  return (
    <React.Fragment>
      {!props.popupCreateAccountState || <CreateAccount onClose={props.onClosePopupCreateAccount}></CreateAccount>}
      <MToolbar menu={menu} logo={props.logo} onLogoClick={props.onLogoClick}>
        <div className={classes['actions']}>
          <div className={classes['lang']}>
            {props.languagesFlag ? <img src={props.currentLanguageState?.image} className={classes['lang__flag']} /> : null}
            <MSelect className={classes['lang__select']} value={props.currentLanguageState?.value} onChange={props.onChangelanguage}>
              {props.languages.map((lang: ILang, index: number) => {
                return (
                  <option key={index} value={lang.value}>
                    {lang.label}
                  </option>
                );
              })}
            </MSelect>
          </div>
          {props.authorization.includes(Authorization.Account) ? (
            props.user ? (
              <div className={classes['profile']}>
                <ProfileSettings></ProfileSettings>
              </div>
            ) : (
              <div className={classes['login']} onClick={props.onOpenPopupCreateAccount}>
                <span className={classes['login__title']}>{t('toolbarNavigation.btnCreateAccount')}</span>
              </div>
            )
          ) : null}
        </div>
      </MToolbar>
    </React.Fragment>
  );
};

ToolbarNavigationView.displayName = 'ToolbarNavigationView';
ToolbarNavigationView.defaultProps = {};

const mapStateToProps = (state: fromApp.AppState): PropsFromState => {
  return {
    user: state.auth.user,
    logo: state.settings.specs?.toolbar.logo || '',
    client: state.settings.specs?.client || null,
    supplier: state.settings.supplierDetails,
    authorization: state.settings.specs?.authorization || [],
  };
};

export default connect(mapStateToProps)(ToolbarNavigationView);
